/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Ranking, Team, TeamRanking } from '../../../../services/betting';
import { LoadingIndicatorContent } from '../../../common/LoadingIndicatorSpinner';
import { TeamLink } from '../../../TeamLink';

interface GroupRankingProps {
    ranking: Ranking;
    isLoading: boolean;
}

export class GroupRanking extends React.Component<GroupRankingProps, {}> {
    ranking(teamRanking: TeamRanking) {
        const team: Team = {
            id: String(teamRanking.teamId),
            miniName: teamRanking.teamMiniName,
            name: teamRanking.teamName,
            shortName: teamRanking.teamShortName,
            sportId: ''
        };
        return (
            <Row key={teamRanking.teamId} className="border-top py-2">
                <Col className="col-1 text-start px-0">{teamRanking.rank}</Col>
                <Col className="col-4 text-start px-0 text-nowrap">
                    <LoadingIndicatorContent isLoading={this.props.isLoading}>
                        <TeamLink teamId={team.id} withIcon={true}/>
                    </LoadingIndicatorContent>
                </Col>
                <Col className="col-2 text-center px-0">{teamRanking.gameCount}</Col>
                <Col className="col-3 text-center px-0">
                    {teamRanking.goals1}&nbsp;:&nbsp;{teamRanking.goals2}
                </Col>
                <Col className="col-2 text-center px-0">{teamRanking.points}</Col>
            </Row>
        );
    }

    render() {
        return (
            <div className="pt-3">
                <h5>{this.props.ranking.tournamentGroupLongName}</h5>
                <Container>
                        <Row className="border-top py-2">
                            <Col className="col-1 d-none d-md-block font-weight-bold text-start px-0">Platz</Col>
                            <Col className="col-1 d-block d-md-none font-weight-bold text-start px-0">Pl</Col>
                            <Col className="col-4 font-weight-bold text-start px-0">Team</Col>
                            <Col className="col-2 d-none d-md-block font-weight-bold text-center px-0">Spiele</Col>
                            <Col className="col-2 d-block d-md-none font-weight-bold text-center px-0">Sp</Col>
                            <Col className="col-3 font-weight-bold text-center px-0">Tore</Col>
                            <Col className="col-2 d-none d-md-block font-weight-bold text-center px-0">Punkte</Col>
                            <Col className="col-2 d-block d-md-none font-weight-bold text-center px-0">Pkt</Col>
                        </Row>
                    {this.props.ranking.rankings.map(r => this.ranking(r))}
                </Container>
            </div>
        );
    }
}
